import React from "react";
import "./styles.scss";
import WofButton from "../WofButton";

const Legal: React.FC<any> = ({
  heading,
  headingFontColor,
  text,
  textFontColor,
  ctaText,
  ctaUrl,
  ctaMultiple,
  ctabaseColor,
  ctahoverColor,
  ctaTextColor,
  ctaTextHoverColor,
  bgColor,
  section_class,
}) => {
  return (
    <div id={section_class} className="legal" style={{background: bgColor}}>
      <div className="row">
        <div className="col-md-12" style={{color: textFontColor}}>
        <h2 style={{color:headingFontColor}}>{heading}</h2>
          <div dangerouslySetInnerHTML={{ __html: text }}/>
        </div>
          {ctaText ? (
            <div className={"text-center col-12"}>
              <WofButton
                baseColor={ctabaseColor}
                hoverColor={ctahoverColor}
                labelHoverColor={ctaTextHoverColor}
                labelColor={ctaTextColor}
                href={ctaUrl}
              >
                {ctaText}
              </WofButton>
            </div>
          ) : null}

          {ctaMultiple ? 
          (<div className={"text-center col-12 cta-multiple"}> {
            ctaMultiple.map((item: any) => (
              <WofButton
                baseColor={ctabaseColor}
                hoverColor={ctahoverColor}
                labelHoverColor={ctaTextHoverColor}
                labelColor={ctaTextColor}
                href={item.ctaUrl}
              > 
                {item.ctaText}
              </WofButton>
            ))}
          </div> )
           : null}
      </div>
    </div>
  );
};
export default Legal;
